import PropTypes from 'prop-types';
import React from 'react';
import MessageComposer from '../messages/MessageComposer.react';
import CloseIcon from '../misc/CloseIcon.react';
import MembersActionCreators from '../../actions/MembersActionCreators.js';
import MemberStore from '../../stores/MemberStore';
const get = require('lodash').get;

const ReactPropTypes = PropTypes;
function getStateFromStores() {
  return {
    submitOnEnter: MemberStore.getSubmitOnEnter(),
  };
}

class GalleryBoxCompliment extends React.Component {
	static propTypes = {
	  complimentSending: ReactPropTypes.bool,
	  onMessageSubmit: ReactPropTypes.func,
	  onClose: ReactPropTypes.func,
	};

	static defaultProps = {
	  complimentSending: false,
	  onMessageSubmit: null,
	  onClose: null,
	};

	constructor(props) {
	  super(props);
	  const store = getStateFromStores();
	  this.state = store;
	}

	render() {
	  return (
  <div className="galleryBoxCompliment">
    <div className="galleryBoxCompliment-inner">
      <MessageComposer
        disabled={this.props.complimentSending}
        senderId={get(globals, 'currentMember.id', op.my_id)}
        showArrow={false}
        showSubscription={false}
        showGiphy={false}
        showImgUpload={false}
        smallInput
        transparent
        disableResize
        onMessageSubmit={this.props.onMessageSubmit}
        ref="composer"
        onChangeEnter={this._onChangeEnter}
        submitOnEnter={this.state.submitOnEnter}
      />
      <div className="galleryBoxCompliment-inner-close">
        <CloseIcon onClick={this.props.onClose} />
      </div>
    </div>
  </div>
	  );
	}

	/**
	 * Event handler - on change enter checkbox
	 */
	_onChangeEnter = (checked) => {
	  MembersActionCreators.submitOnEnter(checked);
	};
}

module.exports = GalleryBoxCompliment;
